export default {
	state: {
		contratacaoContrib: {}
	},
	getters: {
		"contratacaoContrib": state => state.contratacaoContrib
	},
	mutations: {
		setContratacaoContrib(state, payload) {
			state.contratacaoContrib = payload
		}
	},
	actions: {
		atualizarEstadoContratacaoContrib({ commit }, payload) {
			commit('setContratacaoContrib', payload)
		}
	}
};